// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1731":"eccab8701caf107e","8284":"ec0a7f042c757ed1"}[chunkId] + ".js";
};